/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TranslationLabel from '../../../audio-translation/components/web/TranslationLabel';
import { isMobileBrowser } from '../../../base/environment/utils';
import JitsiMeetJS, { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { NARROW_LAYOUT_THRESHOLD } from '../../../base/responsive-ui/constants';
import E2EELabel from '../../../e2ee/components/E2EELabel';
import { isMobileScreenshareFocusMode } from '../../../meeting-ui/functions.any';
import HighlightButton from '../../../recording/components/Recording/web/HighlightButton';
import RecordingLabel from '../../../recording/components/web/RecordingLabel';
import TranscribingLabel from '../../../recording/components/web/TranscribingLabel';
import TimeTimerPill from '../../../time-timer/components/web/TimeTimerPill';
import { isTimeTimerEnabled } from '../../../time-timer/functions';
import { showToolbox } from '../../../toolbox/actions.web';
import { isToolboxVisible } from '../../../toolbox/functions.web';
import VideoQualityLabel from '../../../video-quality/components/VideoQualityLabel.web';
import VisitorsCountLabel from '../../../visitors/components/web/VisitorsCountLabel';
import ConferenceTimer from '../ConferenceTimer';
import { getConferenceInfo } from '../functions.web';
import ConferenceInfoContainer from './ConferenceInfoContainer';
import ConferenceHeaderLeft from './ConferenceHeaderLeft';
import ConferenceHeaderToolbar from './ConferenceHeaderToolbar';
import InsecureRoomNameLabel from './InsecureRoomNameLabel';
import MeetingInfoLabel from './MeetingInfoLabel';
import MobileConferenceHeader from './MobileConferenceHeader';
import RaisedHandsCountLabel from './RaisedHandsCountLabel';
import SpeakerStatsLabel from './SpeakerStatsLabel';
import SubjectText from './SubjectText';
import ToggleTopPanelLabel from './ToggleTopPanelLabel';
/**
 * IDs of {@code COMPONENTS} that the time-timer pill supersedes. When the
 * time-timer is enabled these are hidden from the info bar because their
 * content is already shown inside {@code TimeTimerPill}.
 */
const TIMER_REPLACED_IDS = new Set(['subject', 'conference-timer']);
/** 桌面顶栏不再用右侧胶囊展示会议号/时长；状态类标签仍可留在左侧。 */
const DESKTOP_HEADER_HIDDEN_IDS = new Set([
    'subject',
    'conference-timer',
    'time-timer',
    'highlight-moment',
    'top-panel-toggle'
]);
const COMPONENTS = [
    {
        Component: HighlightButton,
        id: 'highlight-moment'
    },
    {
        Component: SubjectText,
        id: 'subject'
    },
    {
        Component: ConferenceTimer,
        id: 'conference-timer'
    },
    {
        Component: TimeTimerPill,
        id: 'time-timer'
    },
    {
        Component: SpeakerStatsLabel,
        id: 'participants-count'
    },
    {
        Component: E2EELabel,
        id: 'e2ee'
    },
    {
        Component: () => (React.createElement(React.Fragment, null,
            React.createElement(RecordingLabel, { mode: JitsiRecordingConstants.mode.FILE }),
            React.createElement(RecordingLabel, { mode: JitsiRecordingConstants.mode.STREAM }),
            React.createElement(TranscribingLabel, null),
            React.createElement(TranslationLabel, null))),
        id: 'recording'
    },
    {
        Component: RaisedHandsCountLabel,
        id: 'raised-hands-count'
    },
    {
        Component: VideoQualityLabel,
        id: 'video-quality'
    },
    {
        Component: VisitorsCountLabel,
        id: 'visitors-count'
    },
    {
        Component: InsecureRoomNameLabel,
        id: 'insecure-room'
    },
    {
        Component: ToggleTopPanelLabel,
        id: 'top-panel-toggle'
    }
];
/**
 * The upper band of the meeing containing the conference name, timer and labels.
 *
 * @param {Object} props - The props of the component.
 * @returns {React$None}
 */
class ConferenceInfo extends Component {
    /**
     * Initializes a new {@code ConferenceInfo} instance.
     *
     * @param {IProps} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._renderAutoHide = this._renderAutoHide.bind(this);
        this._renderAlwaysVisible = this._renderAlwaysVisible.bind(this);
        this._onTabIn = this._onTabIn.bind(this);
    }
    /**
     * Callback invoked when the component is focused to show the conference
     * info if necessary.
     *
     * @returns {void}
     */
    _onTabIn() {
        if (this.props._conferenceInfo.autoHide?.length && !this.props._visible) {
            this.props.dispatch(showToolbox());
        }
    }
    /**
     * Renders auto-hidden info header labels.
     *
     * @returns {void}
     */
    _renderAutoHide() {
        const { autoHide } = this.props._conferenceInfo;
        const { _timerActive } = this.props;
        if (!autoHide?.length) {
            return null;
        }
        return (React.createElement(ConferenceInfoContainer, { id: 'autoHide', visible: this.props._visible }, COMPONENTS
            .filter(comp => autoHide.includes(comp.id))
            .filter(comp => !_timerActive || !TIMER_REPLACED_IDS.has(comp.id))
            .map(c => React.createElement(c.Component, { key: c.id }))));
    }
    /**
     * Renders the always visible info header labels.
     *
     * @returns {void}
     */
    _renderAlwaysVisible() {
        const { alwaysVisible } = this.props._conferenceInfo;
        const { _timerActive } = this.props;
        if (!alwaysVisible?.length) {
            return null;
        }
        return (React.createElement(ConferenceInfoContainer, { id: 'alwaysVisible', visible: true }, COMPONENTS
            .filter(comp => alwaysVisible.includes(comp.id))
            .filter(comp => !_timerActive || !TIMER_REPLACED_IDS.has(comp.id))
            .filter(comp => !DESKTOP_HEADER_HIDDEN_IDS.has(comp.id))
            .map(c => React.createElement(c.Component, { key: c.id }))));
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _hideConferenceHeader, _mobileScreenshareFocusMode, _reducedUI, _showNarrowHangup, _visible } = this.props;
        if (_reducedUI || _hideConferenceHeader) {
            return null;
        }
        // 手机 / 窄屏：左小窗、中标题+会议信息下拉+时长、右结束
        if (_showNarrowHangup) {
            // 共享聚焦且工具栏隐藏时，顶栏一并隐藏，便于全屏观看共享内容。
            const hideMobileChrome = _mobileScreenshareFocusMode && !_visible;
            const mobileHeaderClassName = [
                'details-container',
                'always-visible-header',
                'mobile-conference-header',
                hideMobileChrome ? 'mobile-chrome-hidden' : ''
            ].filter(Boolean).join(' ');
            return (React.createElement("div", { className: mobileHeaderClassName, onFocus: this._onTabIn },
                React.createElement(MobileConferenceHeader, null)));
        }
        return (React.createElement("div", { className: 'details-container always-visible-header', onFocus: this._onTabIn },
            React.createElement("div", { className: 'conference-header-left' },
                React.createElement(MeetingInfoLabel, null),
                React.createElement(ConferenceHeaderLeft, null),
                this._renderAlwaysVisible()),
            React.createElement("div", { className: 'conference-header-right' },
                React.createElement(ConferenceHeaderToolbar, null))));
    }
}
/**
 * Maps (parts of) the Redux state to the associated
 * {@code Subject}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _visible: boolean,
 *     _conferenceInfo: Object
 * }}
 */
function _mapStateToProps(state) {
    const { isNarrowLayout, reducedUI, videoSpaceWidth } = state['features/base/responsive-ui'];
    const { hideConferenceHeader } = state['features/base/config'];
    // 与 Toolbox 一致：窄屏宽度 / 真机 UA 都显示顶栏右上角「结束」。
    const isWidthNarrow = videoSpaceWidth < NARROW_LAYOUT_THRESHOLD;
    const showNarrowHangup = Boolean(isNarrowLayout || isMobileBrowser() || isWidthNarrow);
    // Electron 客户端自绘顶栏：优先读配置，并兜底识别 Electron UA
    const isElectronClient = Boolean(JitsiMeetJS?.util?.browser?.isElectron?.());
    return {
        _conferenceInfo: getConferenceInfo(state),
        _hideConferenceHeader: Boolean(hideConferenceHeader) || isElectronClient,
        _mobileScreenshareFocusMode: isMobileScreenshareFocusMode(state),
        _reducedUI: reducedUI,
        _showNarrowHangup: showNarrowHangup,
        _timerActive: isTimeTimerEnabled(state) && state['features/time-timer'].running,
        _visible: isToolboxVisible(state)
    };
}
export default connect(_mapStateToProps)(ConferenceInfo);
